export default __webpack_public_path__ + "landing-header.png";